// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

// Components SCSS
import '../../custom/scss/components/breadcrumb/breadcrumb.scss';
import '../../custom/scss/components/hero/hero.scss';
import '../../custom/scss/components/category-overview/category-overview.scss';